import React from 'react';
import { PayPalButtons } from "@paypal/react-paypal-js";
import { Card } from 'react-bootstrap-v5'

export default function PaypalCard({ plan, buttonStyle, createSubscription, onApprove }) {
    return (
        <div className={'col-12 col-lg-4'}>
            <Card>
                <Card.Body>
                    <Card.Title className="text-center">{plan.description}</Card.Title>

                    <div data-plan={plan.id} id="paypal-button-container-{plan.id}">
                        <PayPalButtons
                            style={buttonStyle}
                            createSubscription={(data, actions) => createSubscription(plan.id, actions)}
                            onApprove={async (data, actions) => { await onApprove(data, plan.id) }}
                            onError={(error) => alert(error)}
                        />
                    </div>
                </Card.Body>
            </Card>
        </div>
    )
}
